// removed by extract-text-webpack-plugin
module.exports = {"tourAnchor":"styles__tourAnchor___350WD","tourImage":"styles__tourImage___3CuSG","tourMeta":"styles__tourMeta___2kC14","tourPrice":"styles__tourPrice___1hcfi"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/tour/styles.css
// module id = 4c3f
// module chunks = 2